module.exports = __webpack_public_path__ + "img/icon_guanbi.3a9837ac.svg";